import React from 'react';
import ReactDOM from 'react-dom';
import './styles.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { WorkspaceProvider } from './workspace/WorkspaceContext';

ReactDOM.render(
  <React.StrictMode>
    <WorkspaceProvider>
      <App />
    </WorkspaceProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
